import type { Dict } from "../core.js";
import type { reliability as vi } from "../vi/reliability.js";

export const reliability: Dict<typeof vi> = {
  title: "Reliability",
  subtitle:
    "Services and resources are measured separately — an API that's down while its database is up is two different stories.",
  loadFailed: "Couldn't load reliability data.",
  loadingServices: "Loading services…",
  noServicesTitle: "The catalog has no services yet.",
  noServicesBefore: "Run ",
  noServicesAfter: " to load the catalog from source.",
  services: "Services",
  "col.service": "Service",
  "col.type": "Type",
  "col.tier": "Tier",
  "col.liveness": "Up",
  "col.latency": "Latency",
  "col.owner": "Owner",
  "col.sampledAt": "Sampled",
  "col.version": "Version",
  "col.url": "URL",
  "build.undeclared": "Not declared",
  "summary": "{up} up · {down} not responding · {unmeasured} not measured — of {total} services",
  "sampleHttp": "HTTP",
  "sampleVersion": "build",
  hasOwner: "Assigned",
  noOwner: "No owner",
  "live.notMeasured": "Not measured",
  "live.notProbed": "Not probed",
  "live.up": "Up",
  "live.down": "Not responding",
  loadingResources: "Loading resources…",
  noResources: "No resources yet — the worker adds them on startup, and the catalog seed adds the rest.",
  resources: "Resources",
  "col.resource": "Resource",
  "col.size": "Size",

  loadDetailFailed: "Couldn't load service details.",
  noOwnerAssign: "No owner — assign now",
  blastRadius: "What breaks if it breaks",
  noDependentsBefore: "No service declares a dependency on it. ",
  noDependentsStrong: "Not declared",
  noDependentsAfter: " is not the same as « independent » — the catalog is loaded from source.",
  needs: "What it needs to run",
  noNeeds: "No dependencies or resources declared.",
  healthTitle: "Health — last 50 samples",
  noHealthBefore: "Never probed. If a service doesn't declare ",
  noHealthMiddle: ", the hub doesn't measure it — and that field ",
  noHealthStrong: "can only be changed in source",
  noHealthAfter: ", because the worker calls that address.",
  sampleUp: "up",
  sampleDown: "not responding",
  healthLegendBefore: "Newest on the left. Alternating red and green means ",
  healthLegendStrong: "flapping",
  healthLegendAfter: " — a different problem from a solid red strip, with a different fix.",
  externalLinks: "External links",
  sourceCode: "Source:",
};
